import { useTranslation } from "react-i18next";

/**
 * Hook to get the localized field from an API object.
 * When in French mode, returns the _fr field if available, otherwise falls back to the English field.
 */
export const useLocalized = () => {
  const { i18n } = useTranslation();
  const isFr = i18n.language?.startsWith("fr");

  const l = (item, field) => {
    if (!item) return "";
    if (isFr && item[`${field}_fr`]) return item[`${field}_fr`];
    return item[field] || "";
  };

  const lArr = (item, field) => {
    if (!item) return [];
    if (isFr && item[`${field}_fr`]) return item[`${field}_fr`];
    return item[field] || [];
  };

  return { l, lArr, isFr };
};
